module.exports = __webpack_public_path__ + "static/img/banner.cd1ccc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/banner.png
// module id = m+ct
// module chunks = 1